/*
 * Latest functionality approval:
 *   2015/11/16
 *   NodeBB 0.9.0
 *   nodebb-theme-lavender 3.0.0
 */
define("plugin/shortcuts/themes/lavender/main",["plugin/shortcuts/themes/lavender/selection"],function(a){"use strict";return function(b,c){a(b,c)}});